const { produce } = require("immer");
 
const init = {
  name: null,
  headTitle: null,
  type: null,
  palette: {
    primary: null,
    secondary: null,
    appbar: null,
    link: null,
    info: null,
    warning: null,
    error: null,
    logoBackground: null,
    background: {
      paper: "#fff",
      default: "#fafafa"
    },
  },
  logo: {
    name: null,
    ext: null,
    size: null,
    data: null
  },
  background: {
    name: null,
    ext: null,
    size: null,
    data: null
  },
  favicon: {
    name: null,
    ext: null,
    size: null,
    data: null
  },
  sizeBar: null,
  selectedTypos: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_themeForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    case "UPDATE_themeForm":
      return produce(state, draft => {
        let { name, type, palette, logo, background ,favicon, headTitle, sizeBar,selectedTypos} = action.form;
        if(name) draft.name = name
        if(headTitle) draft.headTitle = headTitle
        if(sizeBar) draft.sizeBar = sizeBar
        if(selectedTypos) draft.selectedTypos = selectedTypos
        if(type) draft.type = type
        if(palette) {
          Object.assign(draft.palette, palette, {
            background: Object.assign(draft.palette.background, palette.background)
          });
        }
        if(logo) Object.assign(draft.logo, logo)
        if(background) Object.assign(draft.background, background)
        if(favicon) Object.assign(draft.favicon, favicon)
      });

    case "RESET_themeForm":
      return init;

    default:
      return state;
  }
}
